// 引入重写的localStorage工具 - 必须最先导入以确保重写全局对象
import storage from "@/utils/storage";

import Vue from "vue";
import VueCompositionAPI from "@vue/composition-api";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import plugins from "./plugins";

import ElementUI from "element-ui";
import "@/assets/styles/element-variables.scss";
import "@/assets/styles/index.scss";
import "@/assets/styles/ruoyi.scss";

import { parseTime, resetForm } from "@/utils";

function initVueApp() {
    Vue.prototype.parseTime = parseTime;
    Vue.prototype.resetForm = resetForm;
    Vue.prototype.storage = storage;

    Vue.use(VueCompositionAPI);
    Vue.use(ElementUI);
    Vue.use(plugins);

    Vue.config.productionTip = false;

    new Vue({
        router,
        store,
        el: "#app",
        render: (h) => h(App)
    }).$mount("#app");
}

initVueApp();
// if (!localStorage.getItem("Token")) {
//     localStorage.clear();
//     window.location.href = process.env.VUE_APP_KW_AUTH_BASE_URL + "auth/goUserLogin?systemType=zdsysSbdwClient";
// } else {
//     initVueApp();
// }
